module.exports = __webpack_public_path__ + "img/MultiLine.f1b3a424.svg";